<template>
  <f7-page id="ua-verify-completed" name="ua-verify-completed" class="bg-color-white" @page:afterin="afterin">
    <div class="block text-align-center">
      <div class="wandr-title-1" v-html="title"></div>
      <p class="mt-md" v-if="statusId != 2 || isFromEKYC">{{ $t('ua-upload-completed-desc') }}</p>
    </div>
    <img :src="require('@/assets/img/icon/icon-success.svg')"/>

    <div class="footer block">
      <f7-button large fill class="mb-md" @click="goToSendMoney">
        {{ $t('sendmoney-title') }}
      </f7-button>
      <f7-button large outline @click="goToContinue">
        {{ $t('sendmoney-continue') }}
      </f7-button>
    </div>
  </f7-page>
</template>

<style>
#ua-verify-completed .wandr-title-1 {
  color: #252525;
  line-height: 30px;
}
#ua-verify-completed p {
  color: var(--f7-color-gray);
  font-size: 14px;
  line-height: 18px;
  font-weight: 500;
}
#ua-verify-completed img {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
#ua-verify-completed .footer{
  position: absolute;
  bottom: 24px;
  left: 0;
  right: 0;
}
</style>

<script>
  import { mapGetters, mapActions } from "vuex";
  export default {
    props: {
      isFromEKYC: Boolean,
    },
    mounted (){
      // Required for everypage. Toggle desktop-view footer.
      this.toggleFooterVisibility(false)
      this.$f7.$('.page-content').on('scroll', (e) => {
        this.toggleFooterVisibility(e.target)
      })

      if(this.isFromEKYC)
        this.title = this.$t('ua-upload-completed-title');

      this.getCustomerDetail();
    },
    data() {
      return {
        title: '',
      }
    },
    methods: {
      ...mapActions('customer', ['setStatusId']),

      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },
      goToSendMoney() {
				this.$f7router.navigate("/sendmoney/select-beneficiary/", { ignoreCache : true, clearPreviousHistory  : true });
      },
      goToContinue() {
        this.$f7router.navigate('/home', { ignoreCache : true, clearPreviousHistory  : true });
      },
      async getCustomerDetail() {
        try {
          this.showPreloader();
          const result = await this.$api.customer.getCustomerDetails();
          this.hidePreloader();
          if(result && result != undefined) {
              this.setStatusId(result.statusId);
          }

          this.title = this.$t((this.statusId == 2 && !this.isFromEKYC)?'ua-completed-send-money-title':'ua-upload-completed-title');
        } catch(e){
          this.hidePreloader();
          if(e.message.toLowerCase().includes("undefined")) {
              this.$f7.dialog.alert(this.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
          } else {
              this.$f7.dialog.alert(e.message);
          }
        }
      }
    },
    computed: {
      ...mapGetters('customer', [
        'statusId',
      ])
    }
  }
</script>